/** Shared helpers for club creation wizard (no React). */

export function slugify(s) {
  return String(s || "")
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

export function clampStr(s, max) {
  const x = String(s || "");
  return x.length > max ? x.slice(0, max) : x;
}

export function cn(...xs) {
  return xs.filter(Boolean).join(" ");
}

/**
 * Normalize upload API response for safe DB storage.
 */
export function normalizeUploadedImage(up) {
  if (!up) return null;
  let s = up.image_url || up.imageUrl || up.url || up.key || up.path || null;
  if (!s) return null;
  s = String(s).trim();
  if (!s) return null;
  if (s.startsWith("undefined/")) s = s.replace(/^undefined\/+/, "");
  if (/^https?:\/\//i.test(s)) return s;
  if (/^clubs\//i.test(s)) return s;
  return s.startsWith("/") ? s : `/${s}`;
}

export function resolveForPreview(storedValue) {
  if (!storedValue) return null;
  let s = String(storedValue).trim();
  if (!s) return null;
  if (s.startsWith("undefined/")) s = s.replace(/^undefined\/+/, "");
  if (/^https?:\/\//i.test(s)) return s;
  const r2Base = process.env.REACT_APP_R2_PUBLIC_BASE || "";
  if (r2Base && /^clubs\//i.test(s)) {
    return `${r2Base.replace(/\/+$/, "")}/${s.replace(/^\/+/, "")}`;
  }
  return s;
}

/**
 * Grouped topic chips — UI + localStorage draft only; no club POST field yet.
 * Compact grid per group for scanability on small modals.
 */
export const CREATION_TOPIC_GROUPS = [
  {
    key: "anime",
    labelEn: "Anime & stories",
    labelJa: "アニメ",
    items: [
      { id: "anime_genres", label: "Anime Genres" },
      { id: "manga_manhwa", label: "Manga / Manhwa" },
      { id: "seasonal", label: "Seasonal Anime" },
      { id: "recommendations", label: "Recommendations" },
      { id: "reviews", label: "Reviews" },
    ],
  },
  {
    key: "hangouts",
    labelEn: "Hangouts & play",
    labelJa: "交流",
    items: [
      { id: "watch_parties", label: "Watch Parties" },
      { id: "gaming", label: "Gaming" },
      { id: "general", label: "General / Off Topic" },
    ],
  },
  {
    key: "fandom",
    labelEn: "Fandom & culture",
    labelJa: "文化",
    items: [
      { id: "fan_art", label: "Fan Art" },
      { id: "cosplay", label: "Cosplay" },
      { id: "amvs_edits", label: "AMVs / Edits" },
      { id: "music_ost", label: "Music / OSTs" },
      { id: "voice_actors", label: "Voice Actors" },
      { id: "collecting", label: "Collecting" },
      { id: "jp_culture", label: "Japanese Culture" },
    ],
  },
];

/** Flat list for label lookup / review line. */
export const CREATION_TOPIC_CHIPS = CREATION_TOPIC_GROUPS.flatMap((g) => g.items);

/**
 * Reddit-style community types mapped to existing API fields.
 * (visibility + join_policy — both validated server-side.)
 */
export const COMMUNITY_TYPE_PRESETS = [
  {
    id: "public",
    title: "Public",
    subtitle: "Anyone can find the club and join instantly.",
    visibility: "public",
    join_policy: "open",
  },
  {
    id: "restricted",
    title: "Restricted",
    subtitle: "Anyone can view posts. New members need approval to join.",
    visibility: "public",
    join_policy: "request",
  },
  {
    id: "private",
    title: "Private",
    subtitle: "Only members can see inside. Invite-only membership.",
    visibility: "private",
    join_policy: "invite",
  },
];

export function presetById(id) {
  return COMMUNITY_TYPE_PRESETS.find((p) => p.id === id) || COMMUNITY_TYPE_PRESETS[0];
}
